import React, { useState, useEffect } from 'react'
import {
	Card,
	CardContent,
	CardHeader,
	Checkbox,
	Collapse,
	IconButton,
	ListItemText,
	makeStyles,
	MenuItem,
	TextField
} from '@material-ui/core'
import { ExpandMoreOutlined } from '@material-ui/icons'
import { DeletableChip } from '../../Misc/DeletableChip'
import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import { cloneDeep } from 'lodash'
import useConstants from '../../../hooks/useConstants'

const useStyles = makeStyles((theme) => ({
	header: {
		padding: '13px 24px',
		userSelect: 'none',
		cursor: 'pointer',
		'& .MuiCardHeader-action': {
			margin: 0
		}
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		'&:last-child': {
			marginBottom: 0
		}
	},
	gridDouble: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '424px !important'
			}
		}
	},
	gridTriple: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(274px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '274px !important'
			},
			'& .MuiFormControl-root': {
				minWidth: '272px !important'
			}
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	footerButton: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	}
}))

const PetKennelingCard = (props) => {
	const classes = useStyles()
	const { tags } = useConstants()

	let { pet, setPet } = props

	const [isExpanded, setIsExpanded] = useState(false)
	const [petKennelTags, setPetKennelTags] = useState([])

	const kennelSizeOptions = ['XS', 'S', 'M', 'L', 'XL']

	useEffect(() => {
		if (tags && pet.tags && pet.tags.kennel && pet.tags.kennel.length) {
			let kennelTags = tags.kennel.filter((tag) => {
				return pet.tags.kennel.findIndex((pt) => pt._id === tag._id) !== -1
			})

			setPetKennelTags(kennelTags)
		} else {
			setPetKennelTags([])
		}
	}, [tags, pet])

	const updatePet = (field, value) => {
		setPet({ ...pet, [field]: value })
	}

	const updateKennelTags = (value) => {
		let updatedTags = cloneDeep(pet.tags)

		updatedTags['kennel'] = value

		updatePet('tags', updatedTags)
	}

	const removeTag = (value) => {
		let updatedTags = cloneDeep(pet.tags)
		let tagIndex = updatedTags['kennel'].findIndex((t) => t._id === value._id)

		if (tagIndex !== -1) {
			updatedTags['kennel'].splice(tagIndex, 1)
		}

		updatePet('tags', updatedTags)
	}

	return (
		<Card>
			<CardHeader
				title="Kenneling"
				className={classes.header}
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, { [classes.expandOpen]: isExpanded })}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>
					<div className={clsx([classes.grid, classes.gridDouble])}>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<TextField
								label="Minimum Kennel Size"
								variant="filled"
								select
								value={pet.minumum_kennel_size || ''}
								disabled={!pet.active}
								onChange={(e) => updatePet('minumum_kennel_size', e.target.value)}>
								{kennelSizeOptions.map((option) => (
									<MenuItem key={option} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>
						</div>
						<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
							<Autocomplete
								multiple
								disableCloseOnSelect
								getOptionLabel={(option) => option.name || ''}
								size="small"
								id="kennel-tags"
								className={classes.autoComplete}
								options={tags && tags.kennel ? tags.kennel : []}
								value={petKennelTags && petKennelTags.length ? petKennelTags : []}
								onChange={(e, v) => updateKennelTags(v)}
								onClose={(e) => {
									e.target.value = ''
								}}
								disabled={!pet.active}
								renderTags={(selected) =>
									selected.map((value) => (
										<DeletableChip
											key={value._id}
											label={value.name}
											{...{ onDelete: pet.active ? () => removeTag(value) : null }}
										/>
									))
								}
								renderOption={(option, { selected }) => (
									<React.Fragment>
										<Checkbox checked={selected} />
										<ListItemText
											style={{ textTransform: 'capitalize' }}
											primary={option.name}
										/>
									</React.Fragment>
								)}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										fullWidth
										label="Select All Kennel Tags"
									/>
								)}
							/>
						</div>
					</div>

				</CardContent>
			</Collapse>
		</Card>
	)
}

export default PetKennelingCard
